/**
 * Pending post-minimize navigation timer.
 * Module-scoped so restore (dock) and minimize (fullscreen) share one handle.
 */
let minimizeNavigationTimerId: number | null = null;

/**
 * Cancel a pending navigate-after-minimize timeout, if any.
 */
export function clearMinimizeNavigation(): void {
  if (minimizeNavigationTimerId == null) {
    return;
  }
  window.clearTimeout(minimizeNavigationTimerId);
  minimizeNavigationTimerId = null;
}

/**
 * Schedule navigation after the minimize slide. Replaces any prior pending timer.
 *
 * @param navigate - Navigation callback to run after the delay.
 * @param delayMs - Delay matching the minimize animation duration.
 */
export function scheduleMinimizeNavigation(
  navigate: () => void,
  delayMs: number
): void {
  clearMinimizeNavigation();
  minimizeNavigationTimerId = window.setTimeout(() => {
    minimizeNavigationTimerId = null;
    navigate();
  }, delayMs) as number;
}

/**
 * Whether a minimize navigation timeout is currently pending.
 * Exposed for unit tests.
 *
 * @returns True when a timer is scheduled.
 */
export function hasPendingMinimizeNavigation(): boolean {
  return minimizeNavigationTimerId != null;
}
